/**
 * TanStack Query hooks for `coupon-code-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	couponCodeWidgetQueryKeys,
	type CreateCouponCodeWidgetBody,
	type CreateCouponCodeWidgetResponse,
	type ListCouponCodeWidgetParams,
	type ListCouponCodeWidgetResponse,
} from "./api";

export function useCouponCodeWidgetList(
	params: ListCouponCodeWidgetParams = {},
): UseQueryResult<ListCouponCodeWidgetResponse, Error> {
	return useQuery({
		queryKey: couponCodeWidgetQueryKeys.list(params),
		queryFn: () => list(params),
	});
}

export function useCouponCodeWidgetCreate(): UseMutationResult<
	CreateCouponCodeWidgetResponse,
	Error,
	CreateCouponCodeWidgetBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: couponCodeWidgetQueryKeys.all });
		},
	});
}
